// src/pages/NotFound.js

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './NotFound.css'
import logoRrWhite from '../../assets/images/logo-rr-white.png'

const NotFound = () => {
  const { t } = useTranslation('screens.NotFound')

  return (
    <div className="oops">
      <header className="oops__header">
        <Link to="/" className="oops__logo-link">
          <img src={logoRrWhite} alt="Revrex Logo" className="oops__logo" />
        </Link>
      </header>

      <main className="oops__main">
        <div className="oops__code" aria-hidden="true">
          404
        </div>

        <h1 className="oops__title">{t('title')}</h1>

        <p className="oops__message">{t('message')}</p>

        <Link to="/" replace className="oops__action">
          <span className="oops__arrow" aria-hidden="true">
            ←
          </span>
          {t('actions.goHome')}
        </Link>
      </main>
    </div>
  )
}

export default NotFound